export default "__VITE_ASSET__03265f88__"